import { render, staticRenderFns } from "./work_order_transfer.vue?vue&type=template&id=f4631824&scoped=true&"
import script from "./work_order_transfer.vue?vue&type=script&lang=js&"
export * from "./work_order_transfer.vue?vue&type=script&lang=js&"
import style0 from "./work_order_transfer.vue?vue&type=style&index=0&id=f4631824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4631824",
  null
  
)

export default component.exports